import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';
import { appendAttachment } from '../utils/FormDataUtils';

export const publicInterestDocumentService = {
  getAll,
  createOrUpdate,
  deletePIDocument
};

const requestOptions = {
  method: 'GET',
  headers: Object.assign(
    {},
    {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  )
};

function getAll(pageNumber, archiveYear) {
  let url = `${
    process.env.REACT_APP_API_URL
  }/api/public_interests/?page[number]=${pageNumber ? pageNumber : 1}`;

  if (archiveYear && archiveYear !== 'all') {
    url = `${url}&archiveYear=${archiveYear}`;
  }

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}

function createOrUpdate(newPublicInterestDocument) {
  const createRequestOptions = {
    method: newPublicInterestDocument.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newPublicInterestDocument)
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    createRequestOptions.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/public_interests${
    newPublicInterestDocument.id ? `/${newPublicInterestDocument.id}` : ''
  }`;

  return fetch(url, createRequestOptions).then(
    responseHandleService.handleResponse
  );
}

function createBodyRequest(publicInterestDocument) {
  let formData = new FormData();

  formData.append('public_interest[title]', publicInterestDocument.title);

  const document = publicInterestDocument.document;

  appendAttachment(formData, `public_interest[document]`, document);

  return formData;
}

function deletePIDocument(piDocumentId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/public_interests/${piDocumentId}`;

  return axios.delete(url, requestOptionsDelete);
}
